export default __webpack_public_path__ + "static/media/Spinner.06a734cd.gif";